


































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/flux/edit/EditParamCW.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray } from '@/utils/groupBy'
import { FluxRestrictFlag } from '@/enum/FluxRestrictFlag'

@Component({
  name: 'ReadParamCw',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    }
  }
})
export default class ReadParamCw extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean

  edit() { 
    (this.$refs.edit as Edit).edit(this.flux)
  }

  get builder() {
    return !!this.$store.myGetters.fluxBuilders[this.flux.bldId]?this.$store.myGetters.fluxBuilders[this.flux.bldId].libelle:"Aucun"
  }


  get restrictionsAccesGroup() {    
    return toSubArray(Object.keys(FluxRestrictFlag),6)
  }   

  get restricted(){
    return this.flux.flxRestrictedFlag && this.flux.flxRestrictedFlag.length >0 &&  this.flux.flxRestrictedFlag != 'none'?this.flux.flxRestrictedFlag.split(', '):[]
  } 
  
}
